import angular from 'angular';
import {DesignPreviewComponent} from './design-preview.component';

export default angular.module('slViz.designPreviewModule', [])
    .component('designPreview', DesignPreviewComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/design-preview/index.js